
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"25","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_19937_132447)","fill":"#000"}},[_c('path',{attrs:{"d":"M20.94 15.598V5.125c0-1.036-.84-1.875-1.876-1.875H5.314c-1.035 0-1.875.84-1.875 1.875v13.75c0 1.035.84 1.875 1.875 1.875h10.474c.497 0 .974-.198 1.326-.55l3.276-3.276c.352-.352.55-.829.55-1.326zm-5 3.125V15.75h2.973l-2.973 2.973zm3.124-13.598v8.75h-4.062a.937.937 0 00-.938.937v4.063h-8.75V5.125h13.75z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.448 9.26H7.93v-2h8.518v2zM12.19 13.068H7.93v-2h4.26v2z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_19937_132447"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(3.44 2)","d":"M0 0h17.5v20H0z"}})])])])
          )
        }
      }
    